import { createSvgIcon } from "@mui/material";

export const EmployeesV2 = createSvgIcon(
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    stroke="currentColor"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M24.0001 24C30.4459 24 35.6667 18.7791 35.6667 12.3333C35.6667 5.88746 30.4459 0.666626 24.0001 0.666626C17.5542 0.666626 12.3334 5.88746 12.3334 12.3333C12.3334 18.7791 17.5542 24 24.0001 24ZM24.0001 29.8333C16.2126 29.8333 0.666748 33.7416 0.666748 41.5V47.3333H47.3334V41.5C47.3334 33.7416 31.7876 29.8333 24.0001 29.8333Z" />
  </svg>,
  "Employees",
);
